import React from "react";
import ProfileHeader from "../../components/Header/ProfileHeader";

export default function ProfileHeaderLayout() {
  return (
    <ProfileHeader />
  );
}
